import { Component, Input, OnInit } from '@angular/core';
import { ChartData, ChartType } from 'chart.js';
export enum LEGEND_POSITION {
    TOP = 'top',
    LEFT = 'left',
    BOTTOM = 'bottom',
    RIGHT = 'right'
}
export enum LEGEND_ALIGN {
    START = 'start',
    CENTER = 'center',
    END = 'end'
}

@Component({
    selector: 'app-doughnut-chart',
    templateUrl: './doughnut-chart.component.html',
    styleUrls: ['./doughnut-chart.component.css']
})
export class DoughnutChartComponent implements OnInit {
    @Input() chartData: number[];
    @Input() doughnutChartLabels: string[];
    @Input() chartColors: string[];
    @Input() legendPosition: LEGEND_POSITION;
    @Input() chartPercentage: string[];
    chartOptions;
    doughnutChartType: ChartType = 'doughnut';
    doughnutChartData;
    legendAlign: LEGEND_ALIGN;

    constructor() {}

    ngOnInit(): void {
        this.handleLegendAlignmentBasedOnPosition();
        this.customDoughnutChartOptions();
        this.setChartData();
    }

    setChartData() {
        this.doughnutChartData = {
            labels: this.doughnutChartLabels,
            datasets: [
                {
                    data: this.chartData,
                    backgroundColor: this.chartColors,
                    chartPercentage: this.chartPercentage
                }
            ]
        };
    }

    handleLegendAlignmentBasedOnPosition() {
        if (this.legendPosition === LEGEND_POSITION.RIGHT) {
            this.legendAlign = LEGEND_ALIGN.CENTER;
        } else if (this.legendPosition === LEGEND_POSITION.TOP) {
            this.legendAlign = LEGEND_ALIGN.START;
        }
    }

    customDoughnutChartOptions() {
        this.chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            cutout: '84%',
            // borderRadius: 50,
            borderWidth: 0,
            // spacing: -30,
            plugins: {
                scale: {
                    pointLabels: {
                        size: 50
                    }
                },
                legend: {
                    onClick: e => e.stopPropagation(),
                    fullSize: false,
                    position: this.legendPosition,
                    align: this.legendAlign,
                    rtl: true,
                    labels: {
                        color: '#707070',
                        boxWidth: 15,
                        boxHeight: 15,
                        font: { size: 13 }
                    }
                },
                tooltip: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            return tooltipItem.dataset.chartPercentage[tooltipItem.dataIndex];
                        }
                    },
                    padding: { top: 10, right: 20, left: 20, bottom: 10 },
                    titleFont: { size: 14, family: 'STCForward-Regular' },
                    bodyAlign: 'right',
                    bodyFont: { size: 13, family: 'STCForward-Regular' },
                    boxPadding: 3,
                    rtl: true
                }
            }
        };
    }
}
